<script>
	document.getElementsByTagName('body')[0].style.display = 'none'
	
	import {sQuery as sq} from './sq.js';
	//export let name;
	import {name, loadProc} from './docs.js'
	import Sqi from './Sq_editorI.svelte'

	if (sq().isPageLoaded())
	{
		console.log('spa loaded')
		setTimeout(() => {
			loadProc( false )
			appendReload()
		}, 1);
	}
	sq(()=>{
		loadProc( false )
		setTimeout(()=>{
			sq('.cJQVer').each(function(){
				const v = sq(this).attr('v')
				sq(this).html(`<a href="https://api.jquery.com/${v}" target=_blank class="notranslate">jQuery ${v}(doc)</a>`)
			})
			appendReload()
		}, 100)
	})
	function appendReload(){
		sq('.cDesc').each(function(){
			sq(this).append('<div class="cReload">reload</div>')
		})
		sq('.cReload').show()
		sq('.cReload').on('click', function(){
			const el = sq(this).parent().parent().find('iframe')
			el.attr('src', el.attr('src') )
		})
	}
</script>

<main>
	<link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/prism/1.25.0/themes/prism-tomorrow.min.css">
	<script src="https://cdnjs.cloudflare.com/ajax/libs/prism/1.25.0/prism.min.js"></script>
	<link rel="stylesheet" href="./Docs.css">
	<section id="idHead">
		<span id="idDocNav"></span>
		<div class="cBtnTrans"><a href="https://squery-vercel-app.translate.goog/?&_x_tr_sl=auto&_x_tr_tl=ja&_x_tr_hl=en&_x_tr_pto=wapp#/install">日本語に翻訳</a></div>
	</section>
	
	<section id="idLeft">
		<section id="idLeftTop">
			<div id="idLeftLogo" class="notranslate"><a href="./" style="color:#fff">sQuery HOME</a></div>
		
			<div id="idLeftSearchCont">
				<hr>
				<div style="position:relative">
					<input id="idDS" type="text" placeholder="search" autocorrect="off" autocapitalize="off" spellcheck="false">
					<div id="idDSC">&times;</div>
				</div>
			</div>
		</section>

		<section class="cScrollable">
			<div style="font-weight:300">
				<div name="" class="cSub">Getting Started</div>
				<div name="Use_with_React" class="cF">・Use with React</div>
				<div name="Use_with_Next" class="cF">・Use with Next.js</div>
				<div name="Use_with_Vue" class="cF">・Use with Vue.js</div>
				<div name="Use_with_Nuxt" class="cF">・Use with Nuxt.js</div>
				<div name="Use_with_Svelte" class="cF">・Use with Svelte</div>
				<div name="Use_with_Sveltekit" class="cF">・Use with SvelteKit</div>
				<div name="Use_with_SolidJS" class="cF">・Use with SolidJS</div>
				<div name="Use_with_Angular" class="cF">・Use with Angular</div>
				<div name="For_TypeScript" class="cF" style="margin-top:30px;font-size:12px">For TypeScript Users</div>
			</div>
	
			<br><br><br><br><br><br><br><br>
		</section>
	</section>
	

	<div class="menu__toggler"><span></span></div>

	<section id="idDoc">
		<h1><span onclick="location.href='./';" style="cursor:pointer">sQuery Install<div>{name}</div></span></h1>

		<doc name="Use_with_React">
			<h2>Use with React</h2>

			<div class="cPreDesc">
				<img class="cFWLogo" src="img/react.png" alt="React.js" title="React.js">
				<ul style="list-style-type: decimal;margin-left:30px;line-height:2;font-size:13px">
					<li>Download & install the latest <a href="https://nodejs.org/" target="_blank">node.js</a> if you didn't install it yet.</li>
					<li>Open the terminal (or Command Prompt if you use Windows), move to the directory anywhere you want to download a new react project using "cd" command or something</li>
					<li>Follow the <a href="https://create-react-app.dev/docs/getting-started" target="_blank">create-react-app</a> tutorial or just try the following commands.</li>	
				</ul>
			</div>
			
			<div>
				<div class="cSh notranslate">
					npx create-react-app@latest test<br><br>
					cd test <b>←The project folder name you created in the above command!</b><br><br>
					npm start
				</div>
				*NOTE*: If you want to use <a href="https://www.typescriptlang.org/" target=_blank>TypeScript</a>, try this instead.
				<div class="cSh notranslate">
					npx create-react-app@latest test --template typescript<br><br>
					cd test<br><br>
					npm start
				</div>

				<hr>
				<h3>Available Commands in project directory</h3><br>
				To launch the site (development):
				<div class="cSh notranslate">
					npm start
				</div>

				To build the site (production):
				<div class="cSh notranslate">
					npm run build
				</div>
			</div>

			<hr>
			<br>
			<div>
				Now, you have a react project folder. Let's launch a local React server. <br>
				You can launch and open the react site locally by just typing <b>npm start</b> in the terminal.<br>
				<img class="cImg" alt="react install" src="img/tutorial/react/1.png">
				<br><br>
				The easiest way to implement sQuery in your React project is just directly adding your sQuery code to a .html file.<br>
				This is just a sample sQuery code to try! (If you prefer the ES6's module style, it's also supported! Use sq.min.js instead!)
				<Sqi cname="reactScript" mh="240" bOnlyCode="1"></Sqi>

				<br>
				In this case, I added the above code in <b>index.html</b> in <b>public folder</b>.
				<img class="cImg" alt="react install" src="img/tutorial/react/script/1.png">

				Worked perfectly!
				<img class="cImg" alt="react install" src="img/tutorial/react/script/2.png">
				<hr>
				If you want to use sQuery in other parts such as inside React modules, I recommend the other way. <br>
				You need to add <b>sq.js and sq.d.ts</b> to your project folder. (In this case, <b>src folder</b>)<br><br>
				This is just a sample sQuery code to try!
				<Sqi cname="reactModule" mh="100" bOnlyCode="1"></Sqi>
				<img class="cImg" alt="react install" src="img/tutorial/react/module/1.png">
				<img class="cImg" alt="react install" src="img/tutorial/react/module/2.png">
			</div>
		</doc>

		<doc name="Use_with_Next">
			<h2>Use with Next.js</h2>

			<div class="cPreDesc">
				<img class="cFWLogo" src="img/next.png" alt="Next.js" title="Next.js">
				<ul style="list-style-type: decimal;margin-left:30px;line-height:2;font-size:13px">
					<li>Download & install the latest <a href="https://nodejs.org/" target="_blank">node.js</a> if you didn't install it yet.</li>
					<li>Open the terminal (or Command Prompt if you use Windows), move to the directory anywhere you want to download a new react project using "cd" command or something</li>
					<li>Follow the <a href="https://nextjs.org/learn/basics/create-nextjs-app/setup" target="_blank">Create a Next.js App</a> tutorial or just try the following commands.</li>	
				</ul>
			</div>
			
			<div>
				<div class="cSh notranslate">
					npx create-next-app nextjs-blog --use-npm --example "https://github.com/vercel/next-learn/tree/master/basics/learn-starter"<br><br>
					cd nextjs-blog <b>←The project folder name you created in the above command!</b><br><br>
					npm start
				</div>

				<hr>
				<h3>Available Commands in project directory</h3><br>
				Starts the development server:
				<div class="cSh notranslate">npm run dev</div>
				
				Builds the site for production:
				<div class="cSh notranslate">npm run build</div>

				Runs the built site in production mode:
				<div class="cSh notranslate">npm start</div>
			</div>
			<hr>
			<br>
			<div>
				Now, you have a Next.js project folder. Let's launch a local Next.js server. <br>
				You can launch and open the Next.js site locally by just typing <b>npm run dev</b> in the terminal.<br>
				<img class="cImg" alt="install" src="img/tutorial/next/1.png">
				
				<hr>
				
				<h3>The Easiest Way</h3>
				<br>
				The easiest way to implement sQuery in your Next.js project is to load sQuery files at a DOM part using a script tag.<br>
				In Next.js, you can't directly write js scripts in index.js, so let's create a js file like the following<br><br>
			
				<Sqi cname="nextScript" mh="100" bOnlyCode="1"></Sqi>

				<br>
				As an example, I added the above code right before the end of <b>main tag</b> in <b>index.js</b> (in <b>pages folder</b>). 
				<img class="cImg" alt="Next.js install" src="img/tutorial/next/script/1.png">
				<br><br>
				Create <b>test.js</b> file in <b>public folder</b> and add the following code in test.js
				<Sqi cname="nextScript2" mh="100" bOnlyCode="1"></Sqi>
				<img class="cImg" alt="Next.js install" src="img/tutorial/next/script/2.png">
				<br><br>
				Worked perfectly!
				<img class="cImg" alt="Next.js install" src="img/tutorial/next/script/3.png">
				
				<hr>
				
				<h3>ES6 Module Type</h3>
				<br>
				The ES6 module type is also supported!<br>
				Add the above code right before the end of <b>main tag</b> in <b>index.js</b> (in <b>pages folder</b>). 
				<Sqi cname="nextModule" mh="50" bOnlyCode="1"></Sqi>
				<img class="cImg" alt="Next.js install" src="img/tutorial/next/module/1.png">
				<br>
				Create <b>test.js</b> file in <b>public folder</b> and add the following code in test.js
				<Sqi cname="nextModule2" mh="150" bOnlyCode="1"></Sqi>
				<img class="cImg" alt="Next.js install" src="img/tutorial/next/module/2.png">
				<br><br>
				Worked perfectly!
				<img class="cImg" alt="Next.js install" src="img/tutorial/next/module/3.png">
				
			</div>
		</doc>

		<doc name="Use_with_Vue">
			<h2>Use with Vue.js</h2>

			<div class="cPreDesc">
				<img class="cFWLogo" src="img/vuejs.png" alt="Vue.js" title="Vue.js">
				<ul style="list-style-type: decimal;margin-left:30px;line-height:2;font-size:13px">
					<li>Download & install the latest <a href="https://nodejs.org/" target="_blank">node.js</a> if you didn't install it yet.</li>
					<li>Open the terminal (or Command Prompt if you use Windows), move to the directory anywhere you want to download a new Vue project using "cd" command or something</li>
					<li>Follow the <a href="https://vuejs.org/guide/quick-start.html" target="_blank">Quick Start</a> tutorial or just try the following commands.</li>	
				</ul>
			</div>
			
			<div>
				<div class="cSh notranslate">
					npm init vue@latest<br><br>
					cd sqvue <b>←The project folder name you created in the above command!(In this tutorial, I set "sqvue")</b><br><br>
					npm install<br><br>
					npm run dev
				</div>

				"npm init vue@latest" would ask you questions about available components. I chose something like this:
				<img class="cImg" alt="vue install" src="img/tutorial/vue/script/terminal.png">

				<hr>
				<h3>Available Commands in project directory</h3><br>
				To launch the site (development):
				<div class="cSh notranslate">npm run dev</div>
				
				To build the site (production):
				<div class="cSh notranslate">npm run build</div>
			</div>
			<hr>
			<br>
			<div>
				Now, you have a Vue project folder. Let's launch a local Vue server. <br>
				You can launch and open the Vue site locally by just typing <b>npm run dev</b> in the terminal.<br>
				<img class="cImg" alt="vue install" src="img/tutorial/vue/1.png">
				<br><br>
				The easiest way to implement sQuery in your Vue project is just directly adding your sQuery code to a .html file.<br>
				This is just a sample sQuery code to try! (If you prefer the ES6's module style, it's also supported! Use sq.min.js instead!)
				<Sqi cname="vueScript" mh="240" bOnlyCode="1"></Sqi>
				<br>
				In this case, I added the above code in <b>index.html</b> in the project folder.
				<img class="cImg" alt="vue install" src="img/tutorial/vue/script/1.png">
				<br>
				Worked perfectly!
				<img class="cImg" alt="vue install" src="img/tutorial/vue/script/2.png">

				<hr>

				<h3>ES6 Module Type</h3>
				<br>
				You can also use sQuery in <b>.vue</b> files, too!<br><br>

				Create <b>test.js</b> file in <b>src folder</b> and add the following code in test.js<br>
				<Sqi cname="vueModule" mh="150" bOnlyCode="1"></Sqi>
				<img class="cImg" alt="vue install" src="img/tutorial/vue/module/1.png">
				<br>

				Add the following code in the script tag in <b>App.vue</b> (in <b>src folder</b>).<br>
				<Sqi cname="vueModule2" mh="50" bOnlyCode="1"></Sqi>
				<img class="cImg" alt="vue install" src="img/tutorial/vue/module/2.png">
				<br>
				Worked perfectly!
				<img class="cImg" alt="vue install" src="img/tutorial/vue/module/3.png">

			</div>
		</doc>

		<doc name="Use_with_Nuxt">
			<h2>Use with Nuxt.js</h2>
			<div class="cPreDesc">
				<img class="cFWLogo" src="img/nuxt.png" alt="Nuxt.js" title="Nuxt.js">
				<ul style="list-style-type: decimal;margin-left:30px;line-height:2;font-size:13px">
					<li>Download & install the latest <a href="https://nodejs.org/" target="_blank">node.js</a> if you didn't install it yet.</li>
					<li>Open the terminal (or Command Prompt if you use Windows), move to the directory anywhere you want to download a new Nuxt.js project using "cd" command or something</li>
					<li>Follow the <a href="https://nuxtjs.org/docs/get-started/installation" target="_blank">Nuxt.js Installation</a> page or just try the following commands.</li>	
				</ul>
			</div>
			
			<div>
				<div class="cSh notranslate">
					npm init nuxt-app sq-nuxt<br><br>
					cd sq-nuxt <b>←The project folder name you created in the above command!</b><br><br>
					npm run dev
				</div>

				"npm init nuxt-app" would ask you questions about components you need. I chose something like this:
				<img class="cImg" alt="nuxt install" src="img/tutorial/nuxt/terminal.png">

				<hr>
				<h3>Available Commands in project directory</h3><br>
				To launch the site (development):
				<div class="cSh notranslate">
					npm run dev
				</div>

				To build the site (production):
				<div class="cSh notranslate">
					npm run build
				</div>

				To start the site (production):
				<div class="cSh notranslate">
					npm run start
				</div>
			</div>

			<hr>
			<br>
			<div>
				Now, you have a Nuxt.js project folder. Let's launch a local Nuxt.js server. <br>
				You can launch and open the Nuxt.js site locally by just typing <b>npm start</b> in the terminal.<br>
				<img class="cImg" alt="Nuxt.js install" src="img/tutorial/nuxt/1.png">
				<br><br>
				
				First, you need to add <b>sq.js and sq.d.ts</b> to your project folder. (In this case, let's use <b>static folder</b>)<br>
				Add the following code in <b>components/Tutorial.vue</b> to test sQuery! (In this example, I added at the end of the script tag)
				<Sqi cname="nuxtModule" mh="100" bOnlyCode="1"></Sqi>
				<img class="cImg" alt="Nuxt.js install" src="img/tutorial/nuxt/module/1.png">

				Worked perfectly!
				<img class="cImg" alt="Nuxt.js install" src="img/tutorial/nuxt/module/2.png">
			</div>
		</doc>


		<doc name="Use_with_Svelte">
			<h2>Use with Svelte</h2>

			<div class="cPreDesc">
				<img class="cFWLogo" src="img/svelte.png" alt="Svelte" title="Svelte">
				<ul style="list-style-type: decimal;margin-left:30px;line-height:2;font-size:13px">
					<li>Download & install the latest <a href="https://nodejs.org/" target="_blank">node.js</a> if you didn't install it yet.</li>
					<li>Open the terminal (or Command Prompt if you use Windows), move to the directory anywhere you want to download a new Svelte project using "cd" command or something</li>
					<li>Follow the <a href="https://svelte.dev/blog/the-easiest-way-to-get-started" target="_blank">The easiest way to get started</a> tutorial or just try the following commands.</li>	
				</ul>
			</div>
			
			<div>
				<div class="cSh notranslate">
					npm create vite@latest sq-svelte -- --template svelte<br><br>
					cd sq-svelte <b>←The project folder name you created in the above command!(In this tutorial, I set "sq-svelte")</b><br><br>
					npm install<br><br>
					npm run dev
				</div>
				<hr>
				<h3>Available Commands in project directory</h3><br>
				To launch the site (development):
				<div class="cSh notranslate">npm run dev</div>
				
				To build the site (production):
				<div class="cSh notranslate">npm run build</div>
			</div>
			<hr>
			<br>
			<div>
				Now, you have a Svelte project folder. Let's launch a local Svelte server. <br>
				You can launch and open the Svelte site locally by just typing <b>npm run dev</b> in the terminal.<br>
				<img class="cImg" alt="Svelte install" src="img/tutorial/svelte/1.png">
				<br><br>
				The easiest way to implement sQuery in your Svelte project is just directly adding your sQuery code to a .html file.<br>
				This is just a sample sQuery code to try! (If you prefer the ES6's module style, it's also supported! Use sq.min.js instead!)
				<Sqi cname="svelteScript" mh="240" bOnlyCode="1"></Sqi>
				<br>
				In this case, I added the above code in <b>index.html</b> in the project folder.
				<img class="cImg" alt="Svelte install" src="img/tutorial/svelte/script/1.png">
				<br>
				Worked perfectly!
				<img class="cImg" alt="Svelte install" src="img/tutorial/svelte/script/2.png">

				<hr>

				<h3>ES6 Module Type</h3>
				<br>
				You can also use sQuery in <b>.svelte</b> files, too!<br><br>

				First, you need to add <b>sq.js and sq.d.ts</b> to your project folder. (In this case, in <b>src folder</b>)<br>
				Add the following code in <b>src/App.svelte</b> to test sQuery!

				<Sqi cname="svelteModule" mh="100" bOnlyCode="1"></Sqi>
				<img class="cImg" alt="Svelte install" src="img/tutorial/svelte/module/1.png">
				<br>
				Worked perfectly!
				<img class="cImg" alt="Svelte install" src="img/tutorial/svelte/module/2.png">

			</div>
		</doc>


		<doc name="Use_with_Sveltekit">
			<h2>Use with Sveltekit</h2>

			<div class="cPreDesc">
				<img class="cFWLogo" src="img/sveltekit.png" alt="Sveltekit" title="Sveltekit">
				<ul style="list-style-type: decimal;margin-left:30px;line-height:2;font-size:13px">
					<li>Download & install the latest <a href="https://nodejs.org/" target="_blank">node.js</a> if you didn't install it yet.</li>
					<li>Open the terminal (or Command Prompt if you use Windows), move to the directory anywhere you want to download a new Sveltekit project using "cd" command or something</li>
					<li>Follow the <a href="https://kit.svelte.dev/docs/introduction#getting-started" target="_blank">Getting Started</a> introduction or just try the following commands.</li>	
				</ul>
			</div>
			
			<div>
				<div class="cSh notranslate">
					npm create svelte@latest sq-sveltekit<br><br>
					cd sq-sveltekit <b>←The project folder name you created in the above command!(In this tutorial, I set "sq-svelte")</b><br><br>
					npm install<br><br>
					npm run dev
				</div>
				<hr>
				<h3>Available Commands in project directory</h3><br>
				To launch the site (development):
				<div class="cSh notranslate">npm run dev</div>
				
				To build the site (production):
				<div class="cSh notranslate">npm run build</div>
			</div>
			<hr>
			<br>
			<div>
				Now, you have a Sveltekit project folder. Let's launch a local Sveltekit server. <br>
				You can launch and open the Sveltekit site locally by just typing <b>npm run dev</b> in the terminal.<br>
				<img class="cImg" alt="Sveltekit install" src="img/tutorial/sveltekit/1.png">
				<br><br>
				The easiest way to implement sQuery in your Sveltekit project is just directly adding your sQuery code to a .html file.<br>
				This is just a sample sQuery code to try! (If you prefer the ES6's module style, it's also supported! Use sq.min.js instead!)
				<Sqi cname="sveltekitScript" mh="240" bOnlyCode="1"></Sqi>
				<br>
				In this case, I added the above code in <b>app.html</b> in src folder.
				<img class="cImg" alt="Sveltekit install" src="img/tutorial/sveltekit/script/1.png">
				<br>
				Worked perfectly!
				<img class="cImg" alt="Sveltekit install" src="img/tutorial/sveltekit/script/2.png">
			</div>
		</doc>


		<doc name="Use_with_SolidJS">
			<h2>Use with SolidJS</h2>
			<div class="cPreDesc">
				<img class="cFWLogo" src="img/solidjs.jpg" alt="SolidJS" title="SolidJS">
				<ul style="list-style-type: decimal;margin-left:30px;line-height:2;font-size:13px">
					<li>Download & install the latest <a href="https://nodejs.org/" target="_blank">node.js</a> if you didn't install it yet.</li>
					<li>Open the terminal (or Command Prompt if you use Windows), move to the directory anywhere you want to download a new SolidJS project using "cd" command or something</li>
					<li>Follow the <a href="https://www.solidjs.com/guides/getting-started" target="_blank">Getting Started Guide</a> or just try the following commands.</li>	
				</ul>
			</div>
			
			<div>
				<div class="cSh notranslate">
					npx degit solidjs/templates/js sq-solid<br><br>
					cd sq-solid <b>←The project folder name you created in the above command!</b><br><br>
					npm i<br><br>
					npm run dev
				</div>
				*NOTE*: If you want to use <a href="https://www.typescriptlang.org/" target=_blank>TypeScript</a>, try this instead.
				<div class="cSh notranslate">
					npx degit solidjs/templates/ts sq-solid<br><br>
					cd sq-solid <b>←The project folder name you created in the above command!</b><br><br>
					npm i<br><br>
					npm run dev
				</div>

				<hr>
				<h3>Available Commands in project directory</h3><br>
				To launch the site (development):
				<div class="cSh notranslate">
					npm start
				</div>

				To build the site (production):
				<div class="cSh notranslate">
					npm run build
				</div>
			</div>

			<hr>
			<br>
			<div>
				Now, you have a SolidJS project folder. Let's launch a local SolidJS server. <br>
				You can launch and open the SolidJS site locally by just typing <b>npm start</b> in the terminal.<br>
				<img class="cImg" alt="solidjs install" src="img/tutorial/solidjs/1.png">
				<br><br>
				The easiest way to implement sQuery in your SolidJS project is just directly adding your sQuery code to a .html file.<br>
				This is just a sample sQuery code to try! (If you prefer the ES6's module style, it's also supported! Use sq.min.js instead!)
				<Sqi cname="solidjsScript" mh="240" bOnlyCode="1"></Sqi>

				<br>
				In this case, I added the above code in <b>index.html</b> in <b>project folder</b>.
				<img class="cImg" alt="solidjs install" src="img/tutorial/solidjs/script/1.png">

				Worked perfectly!
				<img class="cImg" alt="solidjs install" src="img/tutorial/solidjs/script/2.png">
				<hr>
				If you want to use sQuery in other parts such as inside SolidJS modules, I recommend the other way. <br>
				You need to add <b>sq.js and sq.d.ts</b> to your project folder. (In this case, <b>src folder</b>)<br><br>
				This is just a sample sQuery code to try!
				<Sqi cname="solidjsModule" mh="100" bOnlyCode="1"></Sqi>
				<img class="cImg" alt="solidjs install" src="img/tutorial/solidjs/module/1.png">

				Worked perfectly!
				<img class="cImg" alt="solidjs install" src="img/tutorial/solidjs/module/2.png">
			</div>
		</doc>

		<doc name="Use_with_Angular">
			<h2>Use with Angular</h2>
			<div class="cPreDesc">
				<img class="cFWLogo" src="img/angular.png" alt="Angular" title="Angular">
				Go to see the <a href="https://angular.io/start" target="_blank">official installation guide</a> for now.<br>
				I'll update this section soon!
			</div>
		</doc>

		<doc name="For_TypeScript">
			<h2>For TypeScript Users<div style="font-size:14px;margin-left:10px">Easy Workarounds for Known Issues</div></h2>
			
			<div class="cPreDesc">
				<img class="cFWLogo" src="img/typescript.png" alt="TypeScript" title="TypeScript">
				<br>
				There are some minor known issues in TypeScript with sQuery.
				<hr>
				<h3 style="margin-bottom:10px">TypeScript warnings on VSCode</h3>
				In some frameworks like Sveltekit on VSCode, TypeScript might not be able to recognize sQuery object.
				If sq.d.ts file doesn't work, put a <b>nocheck comment</b> at the top of the file.<br>
				<img class="cImg" alt="TypeScript issues" src="img/tutorial/typescript/1.png">
				<br>
				Here are convinient magics to learn!
				<div class="cSh notranslate">
					// @ts-nocheck <b>←disable warnings in the file</b><br><br>
					// @ts-ignore <b>←disable warnings in the next line</b>
				</div>
				<img class="cImg" alt="TypeScript issues" src="img/tutorial/typescript/2.png">
			</div>
		</doc>
	</section>
	<br>
</main>

<style>

</style>